<script>
import coin_svg from "@img/best_price/coin.svg"
import hand_coin_svg from "@img/best_price/hand_coin.svg"
import heavy_truck_svg from "@img/best_price/heavy_truck.svg"
import weight_truck_svg from "@img/best_price/weight_truck.svg"
import IconLike from "@js/components/Icons/IconLike.vue";
import IconStar from "@js/components/Icons/IconStar.vue";
import IconReorder from "@js/components/Icons/IconReorder.vue";
import IconBox from "@js/components/Icons/IconBox.vue";

export default {
    name: "WeHaveBestPrices",
    components: {IconBox, IconReorder, IconStar, IconLike},
    setup() {
        return {
            coin_svg,
            hand_coin_svg,
            heavy_truck_svg,
            weight_truck_svg,
        }
    }
}
</script>

<template>
    <div class="bg-gradient-to-l from-[#2d2d39] to-[#2b2a29] mt-20 pt-14 md:pt-10 pb-14 md:pb-10">
        <div
            class="container">
            <div class="grid grid-cols-1 lg:grid-cols-2 gap-5 md:gap-20">
                <div class="max-w-xl">
                    <p class="text-xl md:text-3xl font-bold text-white mb-5">
                        Лучшие условия на доставку дорожных плит по Москве и МО!
                    </p>
                    <p class="text-white text-xs md:text-sm">
                        Ищете надежные дорожные плиты для строительства дорог, промышленных объектов или временных
                        покрытий? Мы предлагаем ЖБИ-плиты высокого качества, соответствующие ГОСТ, с оперативной
                        доставкой прямо на ваш объект!
                    </p>
                </div>
                <div class="grid grid-cols-1 gap-5 md:gap-10">
                    <div class="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-10">
                        <div>
                            <div class="flex items-center font-semibold text-white text-lg mb-2">
                                <IconLike class="w-6 h-6 me-3 md:me-2"/>
                                Качество
                            </div>
                            <p class="font-normal text-slate-300 text-sm">
                                Прочные и долговечные плиты – выдерживают высокие нагрузки
                            </p>
                        </div>
                        <div>
                            <div class="flex items-center font-bold text-white text-lg mb-2">
                                <IconStar class="w-6 h-6 me-3 md:me-2"/>
                                Преимущества
                            </div>
                            <p class="font-normal text-slate-300 text-sm">
                                Прямая поставка с завода – без посредников и наценок
                            </p>
                        </div>
                    </div>
                    <div class="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-10">
                        <div>
                            <div class="flex items-center font-bold text-white text-lg mb-2">
                                <IconReorder class="w-6 h-6 me-3 md:me-2"/>
                                Доставка
                            </div>
                            <p class="font-normal text-slate-300 text-sm">
                                Быстрая доставка – в любой район Москвы и МО
                            </p>
                        </div>
                        <div>
                            <div class="flex items-center font-bold text-white text-lg mb-2">
                                <IconBox class="w-6 h-6 me-3 md:me-2"/>
                                Ассортимент
                            </div>
                            <p class="font-normal text-slate-300 text-sm">
                                Плиты ПДП, ПАГ, аэродромные, дорожные
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">

</style>
